import { render, staticRenderFns } from "./BadgeKeberadaan.vue?vue&type=template&id=7962617b&"
import script from "./BadgeKeberadaan.vue?vue&type=script&lang=js&"
export * from "./BadgeKeberadaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports